import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { t } from "@configuratorware/configurator-frontendgui/Framework/i18n";
import {
  Button,
  Hidden,
  Icon,
  IconButton,
  Menu,
  Tooltip,
} from "@material-ui/core";
import { Services } from "@configuratorware/configurator-frontendgui/App/ServiceLocator";
import clsx from "clsx";
import Typography from "@material-ui/core/Typography";
import IconSave from "@material-ui/icons/Save";
import IconUpload from "@material-ui/icons/Backup";
import IconMail from "@material-ui/icons/Email";
import IconPDF from "@material-ui/icons/PictureAsPdf";

const useStyles = makeStyles(
  () => ({
    btn: {
      width: "100%",
      textTransform: "none",
      transition: "color 0.3s ease-in-out",
      justifyContent: "flex-start",
      "&:hover": {
        background: "initial",
      },
      "& span": {
        display: "flex",
        gap: "5px",
      },
    },
    iconBtn: {
      width: "36px",
      height: "25px",
      padding: "2px",
      minWidth: "0px",
    },
  }),
  {
    name: "Toolbar",
  }
);

export const Toolbar = ({
  saveEnabled = true,
  shareEnabled = true,
  printEnabled = true,
  loadEnabled = true,
  highlightSave = false,
  isMobile = false,
  ...props
}) => {
  const classes = useStyles();

  const btnSave = (
    <Button
      className={isMobile ? classes.btn : classes.iconBtn}
      onClick={() => Services.interaction.saveConfiguration()}
    >
      <IconSave className={classes.btnSave} />
      {isMobile && (
        <Typography
          variant="body1"
          className={clsx(
            classes.buttonLabel,
            highlightSave && classes.highlight
          )}
        >
          {t("headerMenu.save")}
        </Typography>
      )}
    </Button>
  );

  const btnLoad = (
    <Button
      className={isMobile ? classes.btn : classes.iconBtn}
      onClick={() => Services.interaction.loadConfiguration()}
    >
      <IconUpload />
      {isMobile && (
        <Typography variant="body1" className={classes.buttonLabel}>
          {t("headerMenu.load")}
        </Typography>
      )}
    </Button>
  );

  const btnShare = (
    <Button
      className={isMobile ? classes.btn : classes.iconBtn}
      onClick={async () => {
        await Services.interaction.shareConfiguration();
        Services.ui.show("sendEmail");
      }}
    >
      <IconMail />
      {isMobile && (
        <Typography variant="body1" className={classes.buttonLabel}>
          {t("headerMenu.sendEmail")}
        </Typography>
      )}
    </Button>
  );

  const btnPrint = (
    <Button
      className={isMobile ? classes.btn : classes.iconBtn}
      onClick={() => Services.interaction.printConfigurationAndOpenPdf()}
    >
      <IconPDF />
      {isMobile && (
        <Typography variant="body1" className={classes.buttonLabel}>
          {t("headerMenu.saveAsPdf")}
        </Typography>
      )}
    </Button>
  );

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const toolbarMobileIcon = !open ? "menu" : "close";

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={classes.ToolbarContainer}>
      <>
        {!isMobile ? (
          <>
            {saveEnabled && (
              <Tooltip title={t("headerMenu.save")} arrow>
                {btnSave}
              </Tooltip>
            )}
            {loadEnabled && (
              <Tooltip title={t("headerMenu.load")} arrow>
                {btnLoad}
              </Tooltip>
            )}
            {shareEnabled && (
              <Tooltip title={t("headerMenu.sendEmail")} arrow>
                {btnShare}
              </Tooltip>
            )}
            {printEnabled && (
              <Tooltip title={t("headerMenu.saveAsPdf")} arrow>
                {btnPrint}
              </Tooltip>
            )}
          </>
        ) : (
          <>
            <IconButton
              aria-label="Menu"
              aria-haspopup="true"
              classes={{
                root: classes.ToolbarButton,
                label: classes.ToolbarIconButton,
              }}
              onClick={handleClick}
            >
              <Icon>{toolbarMobileIcon}</Icon>
            </IconButton>
            <Menu
              id="long-menu"
              anchorEl={anchorEl}
              open={open}
              getContentAnchorEl={null}
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              transformOrigin={{ vertical: "top", horizontal: "center" }}
              onClose={handleClose}
              PaperProps={{
                style: {
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  padding: "10px",
                  width: 250,
                },
              }}
            >
              {saveEnabled && btnSave}
              {loadEnabled && btnLoad}
              {shareEnabled && btnShare}
              {printEnabled && btnPrint}
            </Menu>
          </>
        )}
      </>
    </div>
  );
};
